var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hasData)?_c('div',[_c('NoData',{attrs:{"msg":"亲，暂无退款/售后单哦"}})],1):_vm._e(),(_vm.hasData)?_c('div',[_c('ItemSup',{attrs:{"data":_vm.list},on:{"Jump":_vm.Jump}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }